import { render, staticRenderFns } from "./Wallets.vue?vue&type=template&id=37b1cca6&"
import script from "./Wallets.vue?vue&type=script&lang=js&"
export * from "./Wallets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports